import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import { COLORS } from '../styles/colors';
import { loginUser } from '../utils/api';
// 로고 이미지 import
import logoImage from '../assets/tapgo-logo.png';
import RegisterTypeDialog from '../components/RegisterTypeDialog';

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);

  // 환경 변수 로드 상태 확인 (디버깅용)
  useEffect(() => {
    console.log('환경 변수 확인:', {
      adminId: process.env.REACT_APP_ADMIN_ID || '환경 변수 없음',
      adminIdExists: !!process.env.REACT_APP_ADMIN_ID,
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    setIsLoading(true);
    
    try {
      // 로그인 전에 기존 데이터를 모두 초기화
      localStorage.clear();
      
      // 관리자 계정인지 확인
      const isAdmin = userId === 'admin' && password === 'admin1q2w3e';
      
      if (isAdmin) {
        // 관리자 로그인 - 서버 API로 처리
        // Form 데이터 생성
        const formData = new URLSearchParams();
        formData.append('grant_type', 'password');
        formData.append('username', userId);
        formData.append('password', password);
        formData.append('user_type', 'admin'); // 관리자 유형 지정
        
        const BASE_URL = process.env.REACT_APP_BASE_URL;
        const response = await fetch(`${BASE_URL}/api/auth/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString()
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || '관리자 로그인에 실패했습니다.');
        }
        
        const data = await response.json();
        
        // 토큰 저장
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refreshToken', data.refresh_token);
        localStorage.setItem('userType', 'admin');
        
        console.log('관리자 로그인 성공!');
        navigate('/admin/dashboard');
        return;
      }
      
      // 일반 사용자 로그인 (기존 코드)
      const result = await loginUser(userId, password);
      
      // 응답에서 토큰과 사용자 정보 추출
      const { access_token, user_info } = result;
      
      // 토큰 저장
      localStorage.setItem('token', access_token);
      
      // 사용자 정보 저장
      if (user_info) {
        console.log('로그인 성공, 사용자 정보:', user_info);
        
        // 회사 코드가 있는지 확인하고 저장
        if (user_info.middleCompanyCode) {
          console.log('회사 코드 확인:', user_info.middleCompanyCode);
        }
        
        localStorage.setItem('userInfo', JSON.stringify(user_info));
      }
      
      // isPaidUser 값에 따라 리다이렉트
      if (user_info.isPaidUser) {
        navigate('/dashboard'); // 유료 회원은 대시보드로
      } else {
        navigate('/plan-upgrade'); // 무료 회원은 플랜 업그레이드 페이지로
      }
    } catch (error) {
      console.error('로그인 실패:', error);
      setLoginError(error.message || '로그인에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    setShowRegisterDialog(true);
  };

  return (
    <>
      {/* 앱바 추가 */}
      <div className="appBar" style={{ backgroundColor: COLORS.appBar }}>
        <div className="appBarLogo">
          <img src={logoImage} alt="TapGo Logo" className="appBarLogoImage" />
        </div>
      </div>
      
      <div className="loginContainer">
        {/* 중앙 로고 이미지로 변경 */}
        <div className="mainLogoContainer">
          <img 
            src={logoImage} 
            alt="TapGo Logo" 
            className="mainLogo" 
          />
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="formGroup">
            <label className="label">아이디</label>
            <input
              type="text"
              className="input"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="아이디"
              disabled={isLoading}
            />
          </div>
          
          <div className="formGroup">
            <label className="label">비밀번호</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호"
              disabled={isLoading}
            />
          </div>
          
          {loginError && <p className="errorMessage">{loginError}</p>}
          
          <div className="loginButtonGroup">
            <button 
              type="submit" 
              className="loginButton"
              style={{ backgroundColor: COLORS.primary }}
              disabled={isLoading}
            >
              {isLoading ? '로그인 중...' : '로그인'}
            </button>
          </div>
        </form>
        
        <a href="#" onClick={handleRegisterClick} className="registerLink">회원가입</a>
      </div>

      {/* 회원가입 유형 선택 다이얼로그 */}
      <RegisterTypeDialog 
        isOpen={showRegisterDialog} 
        onClose={() => setShowRegisterDialog(false)} 
      />
    </>
  );
};

export default Login; 